import React, { Component, Fragment } from 'react';

import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

// services
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";

// custom
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import BackBtn from 'app/Components/CommanComponents/BackBtn';

export class ViewCompany extends Component {
    constructor(props) {
        super(props)

        this.state = {
            viewId: this.props.match.params.id ? this.props.match.params.id : "",
            viewData: {}
        }
    }

    componentDidMount() {
        this.viewData();
    }

    /*******************Api Call *******************/

    viewData = async () => {
        let response = await optionMasterService.optionMasterByID(this.state.viewId, 0);
        if (response && response.status) {
            if (response.data && response.data) {
                this.setState({
                    viewData: response.data
                })
            }
        }
    }

    render() {
        return (
            <div>
                <MainBreadcrumb
                    routeSegments={[
                        { name: "User Management", path: "#" },
                        { name: "Organisation", path: "/user-management/company" },
                        { name: "View" }
                    ]}
                    breadCrumbsText="User_Management_Organization"
                />
                {this.state.viewData && Object.keys(this.state.viewData).length > 0 &&
                    <Fragment>
                        <div className="row d-flex justify-content-center">
                            <div className="col-md-12">
                                <div className="card mt-4 mb-3">
                                    <div className="card-body">
                                        <div className="simple-card-title">
                                            <h3 class="text-capitalize mb-1">View Organisation</h3>
                                            
                                            <BackBtn url="/user-management/company"/>
                                        </div>
                                        <div className="addressSmlSec" style={{ paddinTop: '0', borderTop: '0' }}>
                                            <Row>
                                                <Col md={3} className="drilingView-bx">
                                                    <h5>Organisation Name</h5>
                                                    <p>{this.state.viewData.metaValue}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <LogHistory
                            subModulename={'option-master-company'}
                            refrenceId={this.state.viewId}
                        ></LogHistory>
                    </Fragment>
                }

            </div>
        )
    }
}

export default ViewCompany


